import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, nextTick, watch, ref } from 'vue'
import type { PropType } from 'vue'
import { useVModel } from '@vueuse/core'
import { listByParamCodes } from '@/api/common'
import { ParamCodeParams } from '@/typings/common'
import { useInteractionStore } from '@/stores/interaction'

export default /*#__PURE__*/_defineComponent({
  __name: 'paramCodesSelect',
  props: {
  value: {
    type: [String, Number, Array]
  },
  label: {
    type: [String, Array]
  },
  record: {
    type: Object
  },
  placeholder: {
    type: String
  },
  paramCode: {
    type: String // 只接受单个
  },
  options: {
    type: Array,
    default: () => {
      return []
    }
  },
  appId: {
    type: String as PropType<ParamCodeParams['appId']>,
    default: 'cos_fbu'
  },
  maxTagCount: {
    type: [Number, String]
  },
  setInitValue: {
    type: Boolean, // 是否设置默认值
    default: false
  },
  fieldNames: Object
},
  emits: ['update:value', 'update:label', 'update:record'],
  setup(__props, { emit: __emit }) {

const props = __props
const optionPage = ref([])
const emit = __emit
const modelValue = useVModel(props, 'value', emit)

const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const pageMaxTagCount = computed(() => {
  if (props.maxTagCount) {
    return props.maxTagCount
  }
  return 'responsive'
})
const fieldNamesComputed = computed(() => {
  // 中英文
  if (props.fieldNames) {
    return props.fieldNames
  }
  return { label: eumns[shareInfo.language] || 'name', value: 'id' }
})
const pageOption = computed(() => {
  let result: any[] = props.options
  if (props.paramCode) {
    result = optionPage.value
  }
  return result && Array.isArray(result) ? result : []
})
const fetch = () => {
  if (props.paramCode) {
    listByParamCodes({
      appId: props.appId,
      paramCodes: [props.paramCode]
    }).then((res) => {
      optionPage.value = props.paramCode && res.data?.[props.paramCode]
    })
  }
}
const filterOption = (input: string, option: any) => {
  let txt = option[eumns[shareInfo.language]]
  if (typeof txt === 'number') {
    txt = txt?.toString()
  }
  return txt?.toLowerCase().indexOf(input.toLowerCase()) >= 0
}
onMounted(() => {
  fetch()
})
const findLabeRecord = (val: any) => {
  if (val && pageOption.value && pageOption.value.length) {
    // 如果modelValue.value 是数组
    if (Array.isArray(val)) {
      const labelAry: any = []
      const recordAry: any = []
      val.forEach((v) => {
        const find: any = pageOption.value.find((item: any) => item.id === v)
        labelAry.push(find?.name)
        recordAry.push(find)
      })
      emit('update:label', labelAry)
      emit('update:record', recordAry)
      return
    }
    const find: any = pageOption.value.find((item: any) => item.id === val)
    emit('update:label', find?.name)
    emit('update:record', find)
  } else {
    emit('update:label')
    emit('update:record')
  }
}
watch(
  () => [modelValue.value, pageOption.value],
  () => {
    findLabeRecord(modelValue.value)
  },
  {
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!

  return (_openBlock(), _createBlock(_component_CosSelect, _mergeProps({ "allow-clear": "" }, _ctx.$attrs, {
    autoLanguage: false,
    value: _unref(modelValue),
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(modelValue) ? (modelValue).value = $event : null)),
    style: {"width":"100%"},
    placeholder: __props.placeholder,
    options: pageOption.value,
    "show-search": "",
    "show-arrow": true,
    "filter-option": filterOption,
    fieldNames: fieldNamesComputed.value,
    "max-tag-count": pageMaxTagCount.value
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["value", "placeholder", "options", "fieldNames", "max-tag-count"]))
}
}

})